import React from "react";

export default function Footer() {
  return (
    <div className="footer-cover col">
      <div className="footer-container">
        <div className="col mr">
          <h2>Get In Touch</h2>
          <h3>About Us</h3>
          <h3>Feedback</h3>
          <h3>Contact Us</h3>
        </div>
        <div className="col mr">
          <h2>Legal</h2>
          <h3>License</h3>
          <h3>Privacy Policy</h3>
          <h3>Terms &#38; Conditons</h3>
        </div>
      </div>
      <h3>What To Watch&#169; 2021</h3>
    </div>
  );
}
